import useVaults from '@/application/read/vaults/useVaults';
import CreatePosition from './CreatePosition';
import useVault from '@/application/read/vaults/useVault';
import { useState } from 'react';
import useAddress from '@/application/read/web3/useAddress';
import useLiquidityPools from '@/application/read/pools/useLiquidityPools';
import type { SelectPoolFormFields } from '@/components/forms/CreatePositionForms/SelectPoolForm';

export interface CreatePositionContainerProps {
  showLp?: boolean;
  showInventory?: boolean;
  showEth?: boolean;
  showNft?: boolean;
  isNewVault?: boolean;
  symbol?: string;
  vaultId?: string;
  withinModal?: boolean;
  poolType?: SelectPoolFormFields['poolType'];
  using?: SelectPoolFormFields['using'];
}

const CreatePositionContainer = ({
  vaultId: initialVaultId,
  isNewVault,
  showEth,
  showInventory,
  showLp,
  showNft,
  withinModal,
  using,
  poolType,
}: CreatePositionContainerProps) => {
  const address = useAddress();
  const [vaultId, setVaultId] = useState<string | undefined>(initialVaultId);
  const { data: vaults } = useVaults();
  const { data: pools } = useLiquidityPools({ exists: true });

  // fetch the selected vault
  const { data: vault } = useVault({ vaultId });

  const isConnected = !!address;

  return (
    <CreatePosition
      fixedVault={initialVaultId != null}
      vault={vault || vaults?.[0]}
      vaults={vaults}
      setVaultId={setVaultId}
      isNewVault={isNewVault}
      showInventory={showInventory}
      showLp={showLp}
      showEth={showEth}
      showNft={showNft}
      withinModal={withinModal}
      isConnected={isConnected}
      pools={pools}
      using={using}
      poolType={poolType}
    />
  );
};

export default CreatePositionContainer;
